const topMenuData = {
    top: [
        {
            type: 'LogoLink',
            href: 'https://nandos.ie',
            className: 'logo',
            text: 'Nando’s'
        },
        {
            type: 'List',
            className: 'menu-top',
            hideFromMobile: true,
            children: [
                {
                    text: 'Log in',
                    className: 'lbutton',
                    href: 'https://www.nandos.ie/card/auth/login',
                    type: 'Link'
                },
                {
                    text: 'Sign up',
                    className: 'lbutton',
                    href: 'https://www.nandos.ie/card/auth/register',
                    type: 'Link'
                },
                {
                    text: 'Menu',
                    href: 'https://www.nandos.ie/food/menu',
                    type: 'Link'
                },
                {
                    type: 'Link',
                    text: 'Restaurants',
                    children: [
                        {
                            type: 'RestaurantLocator',
                            className: 'shorten',
                            text: 'To find a Nando’s enter a town or postcode',
                            market: 'IE'
                        },
                        {
                            type: 'Divider'
                        },
                        {
                            text: 'View All Restaurants',
                            href: 'https://www.nandos.ie/restaurants',
                            type: 'Link'
                        }
                    ]
                },
                {
                    type: 'Link',
                    text: 'Nando’s Rewards',
                    children: [
                        {
                            text: 'Join now',
                            href: 'https://www.nandos.ie/card/auth/register',
                            type: 'Link'
                        },
                        {
                            text: 'How it works',
                            href: 'https://www.nandos.ie/card/about',
                            type: 'Link'
                        },
                        {
                            text: 'Lost Card',
                            href: 'https://www.nandos.ie/card/lost-your-card',
                            type: 'Link'
                        },
                        {
                            type: 'Divider'
                        },
                        {
                            text: 'Log In',
                            href: 'https://www.nandos.ie/card/auth/login',
                            type: 'Link',
                            target: '_blank',
                            className: 'login'
                        }
                    ]
                },
                {
                    text: 'Cook',
                    type: 'Link',
                    children: [
                        {
                            text: 'Products',
                            href: 'https://www.nandos.ie/food/products',
                            type: 'Link'
                        },
                        {
                            text: 'Recipes',
                            href: 'https://www.nandos.ie/food/recipes',
                            type: 'Link'
                        }
                    ]
                },
                {
                    text: 'About Us',
                    className: 'explore',
                    type: 'Link',
                    children: [
                        {
                            text: 'About',
                            type: 'Title'
                        },
                        {
                            text: 'Food',
                            href: 'https://www.nandos.ie/about-us/food',
                            type: 'Link'
                        },
                        {
                            text: 'What’s New',
                            href: 'https://www.nandos.ie/food/whats-new',
                            type: 'Link'
                        },
                        {
                            text: 'Fighting Malaria',
                            href: 'https://www.nandos.ie/explore/fightingmalaria',
                            type: 'Link'
                        },
                        {
                            text: 'Being Sustainable',
                            href: 'https://www.nandos.ie/explore/being-sustainable',
                            type: 'Link'
                        },
                        {
                            text: 'Connect',
                            type: 'Title'
                        },
                        {
                            text: 'The Nando’s App',
                            href: 'https://www.nandos.ie/explore/app',
                            type: 'Link'
                        },
                        {
                            text: 'News',
                            href: 'https://www.nandos.ie/explore/blog',
                            type: 'Link'
                        },
                        {
                            text: 'Experience',
                            type: 'Title'
                        },
                        {
                            text: 'This is PERi-PERi',
                            href: 'https://www.nandos.ie/explore/this-is-peri-peri',
                            type: 'Link'
                        },
                        {
                            text: 'Music',
                            href: 'https://www.nandos.ie/explore/music',
                            type: 'Link'
                        },
                        {
                            text: 'Art',
                            href: 'https://www.nandos.ie/explore/art',
                            type: 'Link'
                        }
                    ]
                },
                {
                    type: 'Link',
                    text: 'Help',
                    children: [
                        {
                            text: 'FAQs',
                            type: 'Title'
                        },
                        {
                            text: 'Search FAQs',
                            href: 'https://help.nandos.ie/hc/en-ie',
                            type: 'Link'
                        },
                        {
                            text: 'My Account',
                            href: 'https://www.nandos.ie/help/my-account',
                            type: 'Link'
                        },
                        {
                            text: 'Food',
                            href: 'https://www.nandos.ie/help/our-food',
                            type: 'Link'
                        },
                        {
                            text: 'Online Ordering',
                            href: 'https://www.nandos.ie/help/online-ordering',
                            type: 'Link'
                        },
                        {
                            text: 'Restaurants',
                            href: 'https://www.nandos.ie/help/our-restaurants',
                            type: 'Link'
                        },
                        {
                            text: 'Nando’s Card & Discounts',
                            href: 'https://www.nandos.ie/help/nandos-cards-gift-cards-discounts',
                            type: 'Link'
                        },
                        {
                            text: 'Fundraising Requests',
                            href: 'https://help.nandos.ie/hc/en-ie/articles/4403417923217-I-Am-Organising-A-Fundraising-Event-Can-You-Help-',
                            type: 'Link'
                        },
                        {
                            text: 'Sustainability',
                            href: 'https://www.nandos.ie/help/sustainability',
                            type: 'Link'
                        },
                        {
                            text: 'Contact',
                            type: 'Title'
                        },
                        {
                            text: 'Contact Us',
                            href: 'https://www.nandos.ie/help/contact',
                            type: 'Link'
                        },
                        {
                            text: 'Resources',
                            type: 'Title'
                        },
                        {
                            text: 'Press Gallery',
                            href: 'https://www.nandos.ie/press-gallery',
                            type: 'Link'
                        }
                    ]
                },
                {
                    type: 'Divider'
                },
                {
                    text: 'Careers',
                    type: 'Link',
                    href: 'https://nandos.careers/',
                    className: 'careers'
                }
            ]
        },
        {
            type: 'List',
            className: 'endgroup',
            children: [
                {
                    title: 'Nando’s Profile',
                    type: 'Link',
                    className: 'login',
                    target: '_blank',
                    href: 'https://www.nandos.ie/profile',
                    text: 'Profile'
                },
                {
                    title: 'Ordering online',
                    className: 'order',
                    type: 'Link',
                    href: 'https://www.nandos.ie/order/search',
                    text: 'Order online'
                },
                {
                    type: 'MobileNavigation',
                    className: 'mobileOpener'
                }
            ]
        }
    ]
};

export { topMenuData };
